import React from 'react';
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, responsiveImageSize, HorizontalPadding } from '../common/responsive.utils';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from "react-router-dom";
import ImageComponent from '../common/Image.component';
import ComponentImage01Web from '../../assets/images/main/web/component-01.png';
import LogoWeb from '../../assets/icon/common/logo_color.svg';
import ComponentImage01Mobile from '../../assets/images/main/mobile/component_01.png';

const MainWeb01Component = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 
    const navigate = useNavigate();

    const onSitter = () => {
        navigate("/sitter");
    }

    const onPartner = () => {
        navigate("/partner");
    }

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.webComponent_Web}>
                        <div style={styles.divBoxHeightVh_Web} />
                        <div style={styles.webRowContainer03_Web}>
                            <ImageComponent
                                src={LogoWeb}
                                alt=""
                                style={styles.webImage09_Web}
                            />

                            <div style={styles.webRowContainer04_Web} >
                                <span style={styles.webTitleButtonText_Web} onClick={() => onSitter()}>
                                    이웃시터 지원하기
                                </span>

                                <div style={{ width: 10 }} />
                                <span style={styles.webTitleButtonText_Web} onClick={() => onPartner()} >
                                    파트너 등록하기
                                </span>
                            </div>
                        </div>

                        <div style={styles.webRowContainer01_Web} >
                            <div style={styles.webTextContainer01_Web} >

                                <div style={{ height: 70 }} />
                                <span style={styles.webTitleText_Web} >
                                    우리 아이 돌봐줄 사람<br />
                                    여기 다 있어요!
                                </span>

                                <div style={{ height: 12 }} />
                                <span style={styles.webContentText_Web} >
                                    출장, 여행 등으로 강아지 고양이<br />
                                    돌봐줄 사람 필요할 때 쉽고 빠르게 찾아보세요!
                                </span>

                                <div style={{ height: 27 }} />
                                <span style={styles.webContentMainColorBoldText_Web}>
                                    #반려인  #펫시터  #펫호텔∙유치원
                                </span>
                            </div>

                            <ImageComponent
                                src={ComponentImage01Web}
                                alt="컴포넌트 이미지"
                                style={styles.webImage01_Web}
                            />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.component_Mobile} >
                        <div style={{ height: "8.7448vh" }} />
                            <div style={styles.textContainer01_Mobile} >
                            <span style={styles.titleText_Mobile} >
                                우리 아이 돌봐줄 사람<br />
                                여기 다 있어요!
                            </span>

                            <div style={{ height: 12 }} />
                            <span style={styles.contentText_Mobile} >
                                출장, 여행 등으로 강아지 고양이<br />
                                돌봐줄 사람 필요할 때 쉽고 빠르게 찾아보세요!
                            </span>

                            <div style={{ height: 6 }} />
                                <span style={styles.contentMainColorBoldText_Mobile} >
                                #반려인  #펫시터  #펫호텔∙유치원
                            </span>
                        </div>

                        <div style={{ height: 28}} />
                        <div style={{ display: "flex", justifyContent: 'center'}} >
                            <img
                                src={ComponentImage01Mobile}
                                style={styles.componentImage01_Mobile}
                                alt="imageComponent"
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    ); 
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    webComponent_Web: { width: "100vw", display: "flex", flexDirection: "column", backgroundColor: "white", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box", paddingLeft: HorizontalPadding(24, 88), paddingRight: responsivePaddingHorizontal(0,100) },
    divBoxHeightVh_Web: { height: responsivePaddingVertical(10, 145)},
    webRowContainer03_Web: {width: "100vw", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", boxSizing: "border-box",margin:"0px"},
    webImage09_Web: { width: responsiveImageSize(0, 66), height: responsiveImageSize(0, 66)},
    webRowContainer04_Web: {width:"100%", display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"flex-end",margin:"0px", paddingRight:  "11vw", },
    webTitleButtonText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(0, 24), fontWeight: "500", letterSpacing: "-0.02em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#454A50", paddingRight: HorizontalPadding(10,40) },
    webRowContainer01_Web: {width:"100%", display:"flex", flexDirection:"row", alignItems:"flex-start", justifyContent:"space-between", padding:"0px",margin:"0px"},
    webTextContainer01_Web: {display:"flex", flexDirection:"column", justifyContent:"flex-start", alignItems:"flex-start"},
    webTitleText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(22, 40), lineHeight:"140%", fontWeight:"700", letterSpacing:"-0.03em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", padding:"0", margin:"0" },
    webContentText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), lineHeight:"140%", fontWeight:"400", letterSpacing:"-0.03em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", padding:"0", margin:"0", color:"#62686D" },
    webContentMainColorBoldText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(13, 33), lineHeight:"140%", fontWeight:"700", letterSpacing:"-0.01em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", padding:"0", margin:"0", color:"#9F6BFF" },
    webImage01_Web: { width: responsiveImageSize(230, 869), height: responsiveImageSize(370, 800), margin:"0", padding:"0"},

    component : { width: "100%", minWidth:"320px", display: "flex", flexDirection: "column", backgroundColor: "white", },
    textContainer01_Mobile: { display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingLeft: HorizontalPadding(24, 24), paddingRight: HorizontalPadding(24, 24) },
    titleText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(22, 40), lineHeight: "140%", fontWeight: "700", letterSpacing: "-0.03em", textAlign: "left", padding: 0, margin: 0, textUnderlinePosition: "from-font", textDecorationSkipInk: "none" },
    contentText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), lineHeight: "140%", fontWeight: "400", letterSpacing: "-0.03em", textAlign: "left", padding: 0, margin: 0, textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#62686D" },
    contentMainColorBoldText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(13, 33), lineHeight: "140%", fontWeight: "700", letterSpacing: "-0.01em", textAlign: "left", padding: 0, margin: 0, textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#9F6BFF" },
    componentImage01_Mobile: { display: "flex", justifyContent: 'center', width: responsiveImageSize(200, 869), height: responsiveImageSize(370, 880), alignItems: "center", boxSizing: "border-box" },
});

export default MainWeb01Component